export default "__VITE_ASSET__BXwo_m68__"